import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"100px","overflow":"hidden"} }

import DialogDelete from "@/components/DialogDelete.vue";
import DialogLoader from "@/components/DialogLoader.vue";
import { onMounted, ref } from "vue";
import dayjs from "dayjs";
import axios from "axios";
import store from "@/store";

type tInvoice = {
  PartitionKey: string;
  RowKey: string;
  name: string;
  TimestampF: string;
  anafErr: string;
  anafState: string;
  anafIncarcare: string;
  anafDescarcare: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'DataTableAnafLog',
  props: {
  showAnafLog: Boolean,
  invoice: Object as () => tInvoice,
},
  emits: ["closeAnafLog"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const anafLog = ref([]);
const dialogDelete = ref(false);
const showLoader = ref(false);

onMounted(() => {
  getAnafLog();
});

function getAnafLog() {
  axios
    .get(`api/v1/anaflog/${props.invoice?.RowKey}`)
    .then((response) => {
      response.data.forEach(
        (log: { Timestamp: string; dateFormated: string }) => {
          log.dateFormated = formatDate(log.Timestamp);
        }
      );
      anafLog.value = response.data;
    })
    .catch((err) => {
      store.dispatch("catchErr", err);
    });
}

function deleteInvoice() {
  showLoader.value = true;
  axios
    .delete(`api/v1/invoicepending/${props.invoice?.RowKey}`)
    .then(() => {
      showLoader.value = false;
      emit("closeAnafLog");
    })
    .catch((err) => {
      dialogDelete.value = false;
      store.dispatch("catchErr", err);
    })
    .finally(() => {
      showLoader.value = false;
    });
}

function formatDate(date: string) {
  return dayjs(date, "YYYYMMDDHHmmss").format("DD/MM/YYYY HH:mm");
}

return (_ctx: any,_cache: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      value: anafLog.value,
      style: {"width":"80vw","max-width":"80vw"},
      scrollHeight: "400px",
      scrollable: "",
      class: "overflow-x-hidden"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "dateFormated",
          header: "date",
          sortable: "",
          sortField: "Timestamp",
          style: {"min-width":"200px"}
        }),
        _createVNode(_component_Column, {
          field: "sev",
          header: "Severity",
          sortable: "",
          style: {"min-width":"100px"}
        }),
        _createVNode(_component_Column, {
          field: "cat",
          header: "Cathegory",
          sortable: "",
          style: {"min-width":"200px"}
        }),
        _createVNode(_component_Column, {
          field: "msg",
          header: "msg",
          sortable: ""
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_1, _toDisplayString(slotProps.data.msg), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"]),
    (
      props.invoice?.anafIncarcare === '' ||
      props.invoice?.anafIncarcare === undefined ||
      (props.invoice?.anafIncarcare !== '' &&
        props.invoice?.anafErr !== '' &&
        props.invoice?.anafErr !== undefined &&
        (props.invoice?.anafDescarcare === '' ||
          props.invoice?.anafDescarcare === undefined))
    )
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          label: "Delete invoice",
          icon: "pi pi-times",
          class: "p-button-rounded p-button-danger mt-3",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogDelete.value = true))
        }))
      : _createCommentVNode("", true),
    _createVNode(DialogDelete, {
      showDelete: dialogDelete.value,
      header: `Delete Invoice?`,
      message: `Are you sure you want to delete ${props.invoice?.name}?`,
      onDelete: _cache[1] || (_cache[1] = (val) => (val ? deleteInvoice() : (dialogDelete.value = false)))
    }, null, 8, ["showDelete", "message"]),
    _createVNode(DialogLoader, { showLoader: showLoader.value }, null, 8, ["showLoader"])
  ], 64))
}
}

})